<template>
  <div class="container">
    <h1 class="text-center">{{ shopTitle }}</h1>
    <h2 class="text-center">Verkäufer-Portal</h2>
    <section id="firebaseui-auth-container">
    </section>
    <!--    <p class="text-center">Melden Sie sich bei Ihrem Support, wenn Sie sich registrieren möchten.</p>-->
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui/dist/esm__de.js"
import "firebaseui/dist/firebaseui.css";
import platformSettings from '~config/settings'

export default {
  name: 'Login',
  data() {
    return {
      ui: null,
      shopTitle: platformSettings.shopTitle
    }
  },
  mounted() {
    let uiConfig = {
      signInSuccessUrl: '/',
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        },
        // firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ]
    }
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    ui.start('#firebaseui-auth-container', uiConfig);
  },
}
</script>

<style>
#firebaseui-auth-container {
  margin: 5%;
}
</style>
